import React from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { usePatient } from "../context/PatientContext";
import "../Styles/patientsidebar.css"; // Make sure this CSS file exists
const PatientSidebar = ({ completedSections = {} }) => {
  const location = useLocation();
  const { patientId, caseId, visitId } = useParams();
  const { patientData } = usePatient();

  const sections = [
    { name: "Symptoms", path: "symptoms" },
    { name: "History", path: "history" },
    { name: "Clinical Investigation", path: "ci" },
    { name: "Anyavyadhi", path: "anyavyadhi" },
    { name: "Kulawrutta", path: "kulawrutta" },
    { name: "Tapasanya", path: "tapasanya" },
    { name: "Artawawrutta", path: "artawawrutta" },
    { name: "Diagnosis", path: "diagnosis" },
    { name: "Treatment", path: "treatment" },
    { name: "Payment", path: "payment" },
    { name: "Next Visit", path: "nextvisit" },
  ];
  const patientInfo = patientData?.patientInfo?.[0] || {};
  const caseTitle = patientData?.caseInfo?.[0]?.CASE_TITLE || "Untitled Case";
  return (
    <div className="sidebar-container">
      <div className="sidebar-header">
        <h3 className="sidebar-patient-name">{patientInfo.PATIENT_NAME}</h3>
        <h4 className="sidebar-patient-id">ID: {patientId}</h4>
        <h4 className="sidebar-case-title">{caseTitle}</h4>
      </div>
      <ul className="sidebar-list">
        {sections.map((section, index) => {
          let fullPath = "";
          if (location.pathname.startsWith(`/visits/${patientId}/${caseId}/${visitId}`)) {
            fullPath = `/visits/${patientId}/${caseId}/${visitId}/${section.path}`;
          }else if (location.pathname.startsWith("/addpatient")){
            fullPath = `/addpatient/${section.path}`;
          }
          const isActive = location.pathname === fullPath;
          const isCompleted = completedSections?.[section.path];

          return (
            <li key={index} className={`sidebar-item ${isActive ? "active" : ""}`}>
              <NavLink to={fullPath} className="sidebar-link">
                <span>{section.name}</span>
                {/* ✅ Hide tick for Patient Info */}
                {section.path !== "" && isCompleted && <span className="tick">✅</span>}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PatientSidebar;
